import { render, staticRenderFns } from "./CPageTitle.vue?vue&type=template&id=2ea43d9c&"
import script from "./CPageTitle.vue?vue&type=script&lang=ts&"
export * from "./CPageTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports